// Higher Qualification Variants Configuration

import { setHigherQualification1 } from "@/store/slices/university";
import type { UniversityState } from "@/store/slices/university";
import { Form_5 } from "@/components/organisms/admin/forms";
import { HIGHER_QUALIFICATION_VARIANTS } from "../../sectionTypes";
import { HIGHER_QUALIFICATION_1_CONSTANTS } from "../../fields/higherQualification/higherQualification_1";
import {
  createHigherQualification,
  updateHigherQualification,
  deleteHigherQualification,
  getHigherQualificationsByUniversitySettingsId,
} from "@/api/admin/higherQualification";
import type { VariantConfig } from "../types";
import { COMMON_CONSTANTS } from "../types";

export const HIGHER_QUALIFICATION_VARIANTS_CONFIG: Record<string, VariantConfig> = {
  [HIGHER_QUALIFICATION_VARIANTS.HIGHER_QUALIFICATION_1]: {
    id: HIGHER_QUALIFICATION_VARIANTS.HIGHER_QUALIFICATION_1,
    name: "Higher Qualification 1",
    description: "Higher Qualification 1",
    componentFields: HIGHER_QUALIFICATION_1_CONSTANTS.HIGHER_QUALIFICATION_FIELDS_CONFIG,
    showTable: false,
    setAction: setHigherQualification1,
    formComponent: Form_5,
    previewComponent: null,
    selector: (state: UniversityState) => state.higher_qualification_1,
    createMethod: createHigherQualification,
    updateMethod: updateHigherQualification,
    fetchMethod: getHigherQualificationsByUniversitySettingsId,
    deleteMethod: deleteHigherQualification,
    hasParentChildStructure: false,
    TREE_CONFIG: HIGHER_QUALIFICATION_1_CONSTANTS.TREE_CONFIG,
    transformDataForPreview: (data: any) => ({ data: data || {} }),
    constants: { ...COMMON_CONSTANTS, SUCCESS_MESSAGE: "Higher qualification saved successfully" },
  },
};

export const getHigherQualificationVariantDetails = (variantId: string) => 
  HIGHER_QUALIFICATION_VARIANTS_CONFIG[variantId];

